import { Card, CardContent, Typography, Box } from '@mui/material';
import BusinessIcon from '@mui/icons-material/Business';

export function UserBusinessDetailsEmptyCard() {
  return (
    <Card variant="outlined" data-testid="user-business-details-empty-card">
      <CardContent>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <BusinessIcon fontSize="small" color="action" />
          <Typography variant="h6" component="h3">
            Business Details
          </Typography>
        </Box>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
          No business details provided yet
        </Typography>
      </CardContent>
    </Card>
  );
}
